import _SelectInput from './SelectInput';

import './style/index.js';

export type { SelectInputProps } from './SelectInput';
export * from './type';

export const SelectInput = _SelectInput;
export default SelectInput;
